export default "__VITE_ASSET__Bq8$wUhe__"